// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__+wd9j","title":"Login_title__vcg8P","form":"Login_form__xawx9","error":"Login_error__ByltQ"};